// extracted by mini-css-extract-plugin
export default {"payButton":"paypal-button_payButton__lesFl"};